import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { getDefaultSdPath } from "@sd/lib/sdPaths";
import { useAuth } from "@sd/hooks/useAuth";

/** Service Desk 404 — role-aware home link. */
export function SdNotFound() {
  const { role } = useAuth();
  const home = getDefaultSdPath(role);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <p className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
          404
        </p>
        <h1 className="mt-2 text-2xl font-bold text-foreground">Page not found</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          You don&apos;t have access to this page, or the link is invalid.
        </p>
        <Button asChild className="mt-6" variant="default">
          <Link to={home}>Go to home</Link>
        </Button>
      </div>
    </div>
  );
}
